import React, { Component } from 'react'
import styled from 'styled-components'
import ContainerArticle from '../../../../components/ContainerArticle'
import ContainerAd from '../../../../components/ContainerAd'
import Text from '../../../../components/Text'
import List from '../../../../components/List'
import translate from '../../../../modules/translate'
import Title from '../../../../components/Title'
import LayoutDefault from '../../../../layouts/Default'
import axios from 'axios'
import errorLog from '../../../../modules/error-log'
import Config from '../../../../config'
import isServerSide from '../../../../modules/is-server-side'

const StyledTitle = styled(Title)`
  font-size: 92px;
  color: ${(props) => props.theme.color.stol};
  font-weight: ${(props) => props.theme.fontWeight.regular};
  margin-bottom: 0;
`

const StyledSubtitle = styled(Title)`
  font-weight: ${(props) => props.theme.fontWeight.regular};
  color: ${(props) => props.theme.color.textPrimary};
  max-width: 470px;
`

const StyledText = styled(Text)`
  font-size: ${(props) => props.theme.fontSize.text};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.tablet.fontSize.text};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.mobile.fontSize.text};
  }
`

const ErrorCode = styled(StyledText)`
  color: ${(props) => props.theme.color.textSecondary};
  margin-bottom: 1.5em;
`

const SmallSubTitle = styled(StyledText)`
  font-weight: ${(props) => props.theme.fontWeight.bold};
`

const StyledList = styled(List)`
  font-size: ${(props) => props.theme.fontSize.text};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.tablet.fontSize.text};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    font-size: ${(props) => props.theme.mobile.fontSize.text};
  }
  margin-bottom: 1.5em;
`

const StyledContainerArticle = styled(ContainerArticle)`
  margin-bottom: 1em;
`

class NotFoundError extends Component {
  constructor(props) {
    super(props)
    this.state = {
      status: 404,
    }
  }
  componentDidMount() {
    let isoLocation =
      this.props.history.location && this.props.history.location.state && this.props.history.location.state.location
        ? this.props.history.location && this.props.history.location.state && this.props.history.location.state.location
        : window && window.location
    if (isoLocation) {
      if (!isServerSide()) {
        let url =
          Config.restUrl('').split('/api/rest/') && Config.restUrl('').split('/api/rest/')[0] + isoLocation.pathname
        axios(url)
          .then((response) => {
            errorLog({ error: 'Got response for undefined screen', info: response, type: 'not-found', level: 'info' })
          })
          .catch((error) => {
            if (error && error.response) {
              this.setState({ status: error.response.status })
            }
          })
      }
    }
  }
  render() {
    const { ...props } = this.props
    return (
      <LayoutDefault>
        <StyledContainerArticle {...props}>
          <StyledTitle>{translate('error_not_found_header')}</StyledTitle>
          <StyledSubtitle tag="h3">{translate('error_not_found_header_message')}</StyledSubtitle>
          <ErrorCode>{translate('error_not_found_code') + ' ' + this.state.status}</ErrorCode>
          <SmallSubTitle>{translate('error_not_found_possibilities')}</SmallSubTitle>
          <StyledList
            items={[
              translate('error_not_found_view_homepage', { link: '/' }),
              translate('error_not_found_to_search', { link: '/suche/bozen' }),
            ]}
          />
          <StyledText>{translate('error_not_found_contact', { mail: 'mailto:redaktion@stol.it' })}</StyledText>
          <ContainerAd adIds={['S3', 'S4']} noGapEdge />
        </StyledContainerArticle>
      </LayoutDefault>
    )
  }
}

NotFoundError.defaultProps = {
  logError: 'NotFoundError',
}

export default NotFoundError
